import { axios } from '../../services/axios';

export default async function postTCAPUserReset(serviceId) {
    return axios
        .post(`/AppAuth/Microsoft/${serviceId}/RequestTCAPUserReset`, null)
        .then((res) => res)
        .catch((e) => e);
}
